import { createContext } from 'react';
import { NavigateOptions } from '@reach/router';

interface DynamicRoutingState extends Record<string, any> {
  navigateTo: (path: string, options?: NavigateOptions<any>) => void;
}

const DynamicRoutingContext = createContext<DynamicRoutingState>({
  navigateTo: () => null,
});

export default DynamicRoutingContext;
